import { render, staticRenderFns } from "./RankingSearchMonthly.vue?vue&type=template&id=53234fca&scoped=true&"
import script from "./RankingSearchMonthly.vue?vue&type=script&lang=js&"
export * from "./RankingSearchMonthly.vue?vue&type=script&lang=js&"
import style0 from "./RankingSearchMonthly.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RankingSearchMonthly.vue?vue&type=style&index=1&id=53234fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53234fca",
  null
  
)

component.options.__file = "packages/cb-components-ranking/src/components/rank/RankingSearchMonthly.vue"
export default component.exports